import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch, { ExtendedCacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { IUserResponse } from "./type.ts";

export const useUsers = () => {
  const { token } = useAuth();

  const fetch = useFetch();

  const { data, isFetching, isError, error } = useQuery<
    IUserResponse | null,
    Error,
    IUserResponse
  >({
    queryKey: ["admins"],
    queryFn: () =>
      fetch<IUserResponse>(Urls.Users, {
        method: "GET",
      }, true, token),
    gcTime: ExtendedCacheTime,
    staleTime: ExtendedCacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting admins");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching,
  };
};
